import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: rh(8),
    gap: rw(12),
  },
  text: {
    flex: 1,
    flexShrink: 1,
  },
  checkbox: {
    borderRadius: rw(6),
    backgroundColor: theme.COLOR_BG_DISABLED,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxMedium: {
    width: rw(20),
    height: rw(20),
  },
  checkboxLarge: {
    width: rw(24),
    height: rw(24),
  },
  checkboxActive: {
    backgroundColor: theme.COLOR_BG_BRAND_PRIMARY,
  },
  checkboxActiveDanger: {
    backgroundColor: theme.COLOR_BG_CRITICAL_PRIMARY,
  },
  card: {
    borderRadius: rw(12),
    paddingVertical: rh(12),
    paddingHorizontal: rw(12),
    backgroundColor: theme.COLOR_BG_SURFACE,
    marginBottom: rh(12),
  },
}))
